import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/consultant/[id]/page.tsx");
